import { KLineData } from "klinecharts";
import { klineLineStyle, lineStyleToKLine } from "./lineStyle";
import { RollingMaxDeque, RollingMinDeque, readStyle } from "./indicatorUtils";

export const createWilliamsR = (settings: any) => {
  const values = settings?.values ?? {};
  const styles = settings?.styles ?? settings?.styleSettings ?? {};
  const period = (values.Period as number) ?? 14;
  const wprS = readStyle(styles, "wpr", "#2196F3");

  return {
    name: "wpr",
    shortName: `WR${period}`,
    calcParams: [period],
    series: "normal" as const,
    minValue: -100,
    maxValue: 0,
    figures: [{ key: "wpr", title: `%R${period}: `, type: "line" }],
    styles: {
      lines: [klineLineStyle(wprS.color, 2, lineStyleToKLine(wprS.style))],
    },
    regenerateFigures: ([p]: number[]) => [
      { key: "wpr", title: `%R${p}: `, type: "line" },
    ],
    calc: (dataList: KLineData[], indicator: { calcParams?: unknown[] }) => {
      const [p] = (indicator.calcParams ?? [period]) as [number];
      const n = dataList.length;
      const results: Array<{ wpr?: number }> = new Array(n);
      const highs: number[] = new Array(n);
      const lows: number[] = new Array(n);
      for (let i = 0; i < n; i++) {
        highs[i] = dataList[i]!.high;
        lows[i] = dataList[i]!.low;
      }

      const maxD = new RollingMaxDeque();
      const minD = new RollingMinDeque();

      for (let i = 0; i < n; i++) {
        maxD.push(i, highs[i]!, highs, p);
        minD.push(i, lows[i]!, lows, p);

        if (i < p - 1) {
          results[i] = {};
          continue;
        }

        const hh = maxD.max(highs);
        const ll = minD.min(lows);
        const close = dataList[i]!.close;
        results[i] = {
          wpr:
            hh === ll ? -50 : (-100 * (hh - close)) / (hh - ll),
        };
      }

      return results;
    },
  };
};
